
import toastr from 'toastr';
import IconPicker from '../../../scripts/iconpicker-1.5.0.js';

angular.module("tags")
    .controller("tagsEditCtrl", ['LoginService', '$scope', '$rootScope', '$controller', '$state', '$stateParams', 'Restangular', 'modalService', '$compile', 'gridService', '$filter', '$translate', '$q','$document', 'entity_type', 'entity_id', function (LoginService, $scope, $rootScope, $controller, $state, $stateParams, Restangular, modalService, $compile, gridService, $filter, $translate, $q, $document, entity_type, entity_id) {

        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("FILES_WRITE");
        $scope.forSearchByTags = false;
        $rootScope.title = $filter('translate')('tags.title');
        $scope.selected = [];

        if (entity_id != null) {
            $scope.forSearchByTags = false;
        } else {
            $scope.forSearchByTags = true;
        }

        $scope.tag = { entity_type: entity_type, color: '#008000' };

        //Icon Picker, usamos angular.element para asegurar que el docuemnto se ha cargado antes de iniciar la función
        //Lo comento por que veo que no se utiliza, se pone directamente un icono
        /*angular.element(function () {
            IconPicker.Init({
                // Required: You have to set the path of IconPicker JSON file to "jsonUrl" option. e.g. '/content/plugins/IconPicker/dist/iconpicker-1.5.0.json'
                jsonUrl: '/assets/iconpicker-1.5.0.json',
                // Optional: Change the buttons or search placeholder text according to the language.
                searchPlaceholder: 'Search Icon',
                showAllButton: 'Show All',
                cancelButton: 'Cancel',
                noResultsFound: 'No results found.', // v1.5.0 and the next versions
                borderRadius: '20px', // v1.5.0 and the next versions
            });

            IconPicker.Run('#GetIconPicker', function () {
                // ng-bind no funciona para asignar el icono porque no detecta el cambio que hacemos con el IconPicker, así que hay que hacerlo a pelo.
                let icon = document.querySelector("#IconPreview").getAttribute("class");
                icon = icon.substring(icon.indexOf('-') + 1);
                $scope.tag.icon = icon;
            });
        });*/

    
        if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {
            $rootScope.breadcrumb = [
                { title: $filter('translate')('tags.title'), url: `tags.list` },
                { title: $filter('translate')('tags.add') },
            ];
        } else {
            $rootScope.breadcrumb = [
                { title: $filter('translate')('tags.title'), url: `tags.list` },
                { title: $filter('translate')('tags.edit') },
            ];
            Restangular.one('Tags', $stateParams.id).get().then(function (result) {
                $scope.tag = result;
            });
        }

        $scope.save = function () {
            $scope.tag.icon = "fas fa-tag";
            if (!angular.isUndefined($scope.tag.id)) {
                $scope.tag.put().then(function (result) {
                    if (typeof (result.id) != "undefined") {
                        toastr.success($filter('translate')('tags.modified_success'));
                        $state.go('tags.list');
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            } else {
                Restangular.all('Tags').post($scope.tag).then(function (result) {
                    if (typeof (result.id) != "undefined") {
                        toastr.success($filter('translate')('tags.created_success'));
                        $state.go('tags.list');
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }
        }


        $scope.selectTagTypes = [
            { id: "persons", name: $filter('translate')('entity_types.persons') },
            { id: "documents", name: $filter('translate')('entity_types.documents') }
        ];

        $scope.checkDelete = function () {
            modalService.confirm({
                title: $filter('translate')('tags.delete'),
                message: $filter('translate')('tags.delete_message'),
                onAccept: function () {
                    $scope.tag.remove().then(function () {
                        toastr.success($filter('translate')('tags.remove_success'));
                        $state.go('tags.list');
                    });
                }
            });
        };

    }])
    .controller("tagsModalCtrl", ['LoginService', '$scope', '$rootScope', '$controller', '$state', '$stateParams', 'Restangular', '$uibModalInstance', 'modalService', '$compile', 'gridService', '$filter', '$translate', '$q', '$document', 'entity_type', 'entity_id', 'selected_tags_ids', 'is_search', function (LoginService, $scope, $rootScope, $controller, $state, $stateParams, Restangular, $uibModalInstance, modalService, $compile, gridService, $filter, $translate, $q, $document, entity_type, entity_id, selected_tags_ids, is_search) {

        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("FILES_WRITE");
        $scope.forSearchByTags = false;

        if (entity_id != null) {
            $scope.forSearchByTags = false;
        } else {
            $scope.forSearchByTags = true;
        }

        $scope.tag = { entity_type: entity_type, color: '#008000' };
      
        Restangular.all("Tags").customGET("TagsByEntityType", { entity_type: entity_type, entity_id: entity_id }).then(function (result) {

            $scope.tags = result;
            let noTag = { id: 0, checked: false};

            if (is_search) {
                $scope.tags = [noTag, ...result]
            }
            else {
                $scope.tags = result;
            }

            // Cogemos los tags que ya tiene asignados la entidad y los marcamos
            $scope.tags.forEach(function (tag) {
                if (selected_tags_ids != null && selected_tags_ids.includes(tag.id)) tag.checked = true;
            })

            $scope.tagsLoaded = true;

        });

        $scope.selectTagTypes = [
            { id: "persons", name: $filter('translate')('entity_types.persons') },
            { id: "documents", name: $filter('translate')('entity_types.documents') }
        ];

        $scope.checkDelete = function () {
            modalService.confirm({
                title: $filter('translate')('tags.delete'),
                message: $filter('translate')('tags.delete_message'),
                onAccept: function () {
                    $scope.tag.remove().then(function () {
                        toastr.success($filter('translate')('tags.remove_success'));
                        $state.go('tags.list');
                    });
                }
            });
        };

        $scope.onCancelTag = function () {
            $uibModalInstance.dismiss();
        };

        $scope.onAcceptTag = function () {

            $scope.tag.icon = "fas fa-tag";

            if (angular.isUndefined($scope.tag.color)) {
                $scope.tag.color = "#008000"
            }
            Restangular.all('Tags').post($scope.tag).then(function (result) {
                if (typeof (result.id) != "undefined") {
                    toastr.success($filter('translate')('tags.created_success'));
                } else 
                    $scope.errorMessage = result.message;
            })  

            $uibModalInstance.close();

        }
       
        $scope.onAssignTags = function () {

            let selected_ids = $scope.tags.filter(m => m.checked).map(m => m.id);

            angular.forEach(selected_ids, function (item) {
                    Restangular.all('Tags').customPOST({}, "SaveTagsEntity", { tag_id: item, entity_id: entity_id }).then(function (result) {
                    })
            })

            $uibModalInstance.close();

        }

        $scope.onSearchByTags = function () {
            let selected_ids = $scope.tags.filter(m => m.checked).map(m=>m.id);
            $uibModalInstance.close(selected_ids);
        }

    }]);

